import type { FC } from 'react';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Text } from '@sravni/react-design-system/lib/Typography';
import { useBoolean } from '@sravni/react-utils';

import { ServiceList } from '@components/ServiceFilter/src/components/ServiceList/ServiceList';
import { ServiceDialog } from '@components/ServiceFilter/src/components/ServicesDialog/ServiceDialog';

import { FILTERS_NAME } from '../../../constants/filters';
import { sendChangeServiceEvent } from '../../../helpers/analyticsEvents';
import { useFilters } from '../../../store/hooks/filters';
import { useServices } from '../../../store/hooks/services';
import { setFilters } from '../../../store/reducers/filters';
import type { TService } from '../../../types/services';

type FiltersProps = {
  className?: string;
};

export const ServiceFilter: FC<FiltersProps> = ({ className }) => {
  const filters = useFilters();
  const allServices = useServices();
  const dispatch = useDispatch();

  const [isDialogVisible, setDialogVisibility] = useBoolean(false);

  const servicesForActualCustomerType = allServices?.[filters.customerType];

  const handleChangeService = useCallback(
    (service: TService) => () => {
      if (
        service.key === filters[FILTERS_NAME.Service]?.key &&
        service.customerType === filters[FILTERS_NAME.Service].customerType
      ) {
        // если выбранная услуга совпадает с текущей
        return;
      }

      const newFilter = {
        ...filters,
        service,
        customerType: service.customerType,
      };

      sendChangeServiceEvent(service);
      dispatch(setFilters(newFilter));
      setDialogVisibility.off();
    },
    [dispatch, filters, setDialogVisibility],
  );

  const handleClickMoreButton = useCallback(() => {
    setDialogVisibility.on();
  }, [setDialogVisibility]);

  const handleClose = useCallback(() => setDialogVisibility.off(), [setDialogVisibility]);

  if (!servicesForActualCustomerType || servicesForActualCustomerType.length < 2) return null; // если нет услуг или она всего одна

  return (
    <div className={className}>
      <Text size={14} strong>
        По услугам
      </Text>
      <ServiceList onChangeService={handleChangeService} onClickMoreButton={handleClickMoreButton} />
      <ServiceDialog isVisible={isDialogVisible} onClose={handleClose} onChangeService={handleChangeService} />
    </div>
  );
};
